import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CtaProps, ImageCard } from '../../../atoms';
import { CHECKOUT_URLS } from '../../../config';
import { useAnalytes, useMe } from '../../../config/api/queries';
import { capitalizeFirstLetter } from '../../../utils';

export const BloodResultsCard = ({
  testType,
  scrollToOrderTracking,
}: {
  testType: 'vitamin' | 'mineral';
  scrollToOrderTracking?: () => void;
}): JSX.Element => {
  const analyteReport = useAnalytes();
  const me = useMe();
  const navigate = useNavigate();
  const isVitamin = testType === 'vitamin';

  const bloodStates: { [name: string]: CtaProps } = {
    results_available: {
      btnId: `blood-${testType}-results`,
      text: 'View full report',
      subText: `Order blood ${testType} test`,
      subTextLink: isVitamin
        ? CHECKOUT_URLS.blood_test.link
        : CHECKOUT_URLS.blood_mineral_test.link,
      func: () => navigate(`/dashboard/blood-${testType}-report`),
    },
    // TODO - can bring back if new blood tests are added
    // ordered: {
    //   btnId: `blood-${testType}-track-order`,
    //   text: 'Track Order',
    //   subText: 'We got your order!',
    //   func: () =>
    //     scrollToOrderTracking
    //       ? scrollToOrderTracking()
    //       : navigate('/dashboard'),
    // },
    // needs_order: {
    //   btnId: `blood-${testType}-report-order`,
    //   text: `Order blood ${testType} test`,
    //   subText: 'Results within 2 weeks',
    //   link: isVitamin
    //     ? CHECKOUT_URLS.blood_test.link
    //     : CHECKOUT_URLS.blood_mineral_test.link,
    // },
  };

  const [bloodState, setBloodState] = useState<CtaProps>();

  useEffect(() => {
    if (analyteReport?.data?.length) {
      // Filter out the report data based on testType
      const relevantReports = analyteReport?.data?.filter(
        (report) => report.test_type === testType
      );

      // Check if any report from the filtered data has result history
      const hasResults = relevantReports.some(
        (report) => report.result_history.length > 0
      );

      if (hasResults) {
        setBloodState(bloodStates.results_available);
      }
    }
  }, [analyteReport.data, me.data]);

  return (
    <ImageCard
      image={
        isVitamin
          ? '/images/blood_vitamin_result_card.jpg'
          : '/images/blood_mineral_result_card.jpg'
      }
      alttext="image of blood cells"
      variant="halfImage"
      title={`Blood ${capitalizeFirstLetter(testType)} Report`}
      description={
        isVitamin
          ? `Get precise doses of the vitamins and complex compounds your body needs to perform at its best.`
          : 'Discover where are your levels are today and get to the root of what your body may need.'
      }
      cta={bloodState}
    />
  );
};
